import { useEffect, useState } from 'react';
import { ArrowRightLeft, Check, X } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

export const TransferRequestsPanel = ({ api, onChanged }) => {
    const [transfers, setTransfers] = useState([]);
    const [busyId, setBusyId] = useState(null);

    const load = async () => {
        try {
            const { data } = await api.get('/company-transfers');
            setTransfers(data);
        } catch (error) {
            console.error('Failed to fetch transfers:', error);
        }
    };

    useEffect(() => {
        load();
        window.addEventListener('company-transfers-changed', load);
        return () => window.removeEventListener('company-transfers-changed', load);
    }, []);

    const decide = async (id, action) => {
        setBusyId(id);
        try {
            const { data } = await api.post(`/company-transfers/${id}/${action}`);
            toast.success(data.message);
            await load();
            onChanged?.();
        } catch (error) {
            toast.error(error.response?.data?.detail || 'Erreur lors du traitement');
        } finally {
            setBusyId(null);
        }
    };

    if (transfers.length === 0) return null;

    return (
        <Card className="border-amber-500/40 bg-amber-500/5" data-testid="transfer-requests-panel">
            <CardContent className="p-5 space-y-3">
                <div className="flex items-center gap-2 font-medium">
                    <ArrowRightLeft className="w-4 h-4 text-amber-600" />
                    Demandes de transfert en attente ({transfers.length})
                </div>
                {transfers.map((t) => (
                    <div key={t.id} className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 rounded-lg bg-background/70 px-4 py-3" data-testid={`transfer-request-${t.id}`}>
                        <p className="text-sm">
                            <span className="font-medium">{t.requester_name}</span> demande « <span className="font-medium">{t.company_name}</span> »
                            <span className="text-muted-foreground"> — détenu par {t.owner_name}</span>
                        </p>
                        {t.can_decide ? (
                            <div className="flex gap-2">
                                <Button size="sm" className="rounded-full" disabled={busyId === t.id} onClick={() => decide(t.id, 'accept')} data-testid={`transfer-accept-${t.id}`}>
                                    <Check className="w-4 h-4 mr-1" /> Accepter
                                </Button>
                                <Button size="sm" variant="outline" className="rounded-full" disabled={busyId === t.id} onClick={() => decide(t.id, 'reject')} data-testid={`transfer-reject-${t.id}`}>
                                    <X className="w-4 h-4 mr-1" /> Refuser
                                </Button>
                            </div>
                        ) : (
                            <span className="text-xs text-muted-foreground" data-testid={`transfer-pending-${t.id}`}>En attente de réponse</span>
                        )}
                    </div>
                ))}
            </CardContent>
        </Card>
    );
};
